<app-command-detail [order]="data"
                    (exit)="onExit()"
                    (trackOrder)="goToTrackOrder($event)">
  ></app-command-detail>
